/**
 * DIEUKYDIEU.TV - DESKTOP & GLOBAL SEARCH MODULE
 */
import { t } from './i18n.js';
import { showToast } from './ui.js';
import { renderEmptyStateHTML } from './components/index.js';
import {
    SEARCH_HISTORY_KEY, DEFAULT_SEARCH_HISTORY, POPULAR_SEARCH_TOPICS, getFeaturedSuggestions,
    FEATURED_SUGGESTIONS, MOCK_AUTHORS, getUnifiedSearchDatabase, getSearchHistory, saveSearchHistory,
    addSearchHistory, removeSearchHistory, clearAllSearchHistory
} from './modules/search-db.js';
import {
    removeVietnameseTones, highlightMatch, escapeHtml, escapeRegExp, filterSearchDatabase,
    createMediaRowHTML, renderSearchTopicChip, renderFeaturedCardHTML, renderDesktopEmptyState
} from './modules/search-utils.js';
import {
    openMobileSearch, closeMobileSearch, clearMobileSearch, fillMobileSearch, handleMobileSearch,
    renderMobileEmptyState, renderMobileResults, renderQuickSearchResults
} from './modules/search-mobile.js';
import { initSearchEvents } from './modules/search-events.js';

export {
    SEARCH_HISTORY_KEY, DEFAULT_SEARCH_HISTORY, POPULAR_SEARCH_TOPICS, getFeaturedSuggestions,
    FEATURED_SUGGESTIONS, MOCK_AUTHORS, getUnifiedSearchDatabase, getSearchHistory, saveSearchHistory,
    addSearchHistory, removeSearchHistory, clearAllSearchHistory, removeVietnameseTones, highlightMatch,
    escapeHtml, escapeRegExp, filterSearchDatabase, createMediaRowHTML, renderSearchTopicChip,
    renderFeaturedCardHTML, renderDesktopEmptyState, openMobileSearch, closeMobileSearch, clearMobileSearch, fillMobileSearch,
    handleMobileSearch, renderMobileEmptyState, renderMobileResults, renderQuickSearchResults,
    initSearchEvents
};

let desktopActiveIndex = -1;

export function focusDesktopSearch() {
    if (window.innerWidth < 1024) {
        if (typeof window.closeMobileSidebar === 'function') window.closeMobileSidebar();
        if (typeof window.openMobileSearch === 'function') window.openMobileSearch();
        return;
    }
    const input = document.getElementById('desktop-search-input');
    if (input) {
        input.focus();
        handleDesktopSearchFocus();
    }
}

export function handleDesktopSearchFocus() {
    if (window.innerWidth < 1024) {
        if (typeof window.closeMobileSidebar === 'function') window.closeMobileSidebar();
        if (typeof window.openMobileSearch === 'function') window.openMobileSearch();
        return;
    }
    const input = document.getElementById('desktop-search-input');
    const resultsBox = document.getElementById('desktop-search-results');
    const backdrop = document.getElementById('spotlight-backdrop');
    if (!resultsBox) return;

    resultsBox.classList.add('show');
    if (backdrop) backdrop.classList.add('show');
    if (input && input.value.trim().length > 0) {
        renderDesktopResults(input.value.trim(), resultsBox);
    } else {
        renderDesktopEmptyState(resultsBox);
    }
}

export function handleDesktopSearch(val) {
    const clearBtn = document.getElementById('desktop-search-clear');
    const searchBar = document.getElementById('header-search-bar');
    const resultsBox = document.getElementById('desktop-search-results');
    const backdrop = document.getElementById('spotlight-backdrop');
    desktopActiveIndex = -1;

    if (val.trim().length > 0) {
        if (clearBtn) clearBtn.classList.add('show');
        if (searchBar) searchBar.classList.add('has-value');
        if (resultsBox) {
            resultsBox.classList.add('show');
            if (backdrop) backdrop.classList.add('show');
            renderDesktopResults(val.trim(), resultsBox);
        }
    } else {
        if (clearBtn) clearBtn.classList.remove('show');
        if (searchBar) searchBar.classList.remove('has-value');
        if (resultsBox) {
            renderDesktopEmptyState(resultsBox);
        }
    }
}

export function renderDesktopResults(query, containerEl, showAll = false, filterType = 'all') {
    const allMatches = filterSearchDatabase(query, 'all');
    const totalCount = allMatches.length;
    const matches = filterType === 'all' ? allMatches : allMatches.filter(item => item.type === filterType);

    if (matches.length === 0) {
        const topicChips = POPULAR_SEARCH_TOPICS.slice(0, 4).map(tp => renderSearchTopicChip(tp, false)).join('');

        containerEl.innerHTML = `
            <div class="search-dropdown-body search-empty-results">
                ${renderEmptyStateHTML({
                    icon: 'search_off',
                    title: t('search_no_results') || 'Không tìm thấy kết quả phù hợp',
                    desc: 'Thử khám phá các chủ đề phổ biến:'
                })}
                <div class="search-chips-wrap">
                    ${topicChips}
                </div>
            </div>
        `;
        return;
    }

    const displayMatches = showAll ? matches : matches.slice(0, 5);
    const rowsHtml = displayMatches.map(item => createMediaRowHTML(item, query, false)).join('');

    let filterTabsHtml = '';
    if (showAll || totalCount > 5) {
        const counts = { all: totalCount, video: 0, audio: 0, article: 0 };
        for (let i = 0; i < allMatches.length; i++) {
            const tType = allMatches[i].type;
            if (counts[tType] !== undefined) counts[tType]++;
        }
        filterTabsHtml = `
            <div class="search-filter-tabs">
                <button class="search-filter-tab ${filterType === 'all' ? 'active' : ''}"
                        onclick="renderDesktopResults(document.getElementById('desktop-search-input')?.value || '', document.getElementById('desktop-search-results'), true, 'all')">
                    ${t('search_filter_all')} (${counts.all})
                </button>
                ${counts.video > 0 ? `
                <button class="search-filter-tab ${filterType === 'video' ? 'active' : ''}"
                        onclick="renderDesktopResults(document.getElementById('desktop-search-input')?.value || '', document.getElementById('desktop-search-results'), true, 'video')">
                    ${t('search_filter_video')} (${counts.video})
                </button>` : ''}
                ${counts.audio > 0 ? `
                <button class="search-filter-tab ${filterType === 'audio' ? 'active' : ''}"
                        onclick="renderDesktopResults(document.getElementById('desktop-search-input')?.value || '', document.getElementById('desktop-search-results'), true, 'audio')">
                    ${t('search_filter_audio')} (${counts.audio})
                </button>` : ''}
                ${counts.article > 0 ? `
                <button class="search-filter-tab ${filterType === 'article' ? 'active' : ''}"
                        onclick="renderDesktopResults(document.getElementById('desktop-search-input')?.value || '', document.getElementById('desktop-search-results'), true, 'article')">
                    ${t('search_filter_articles')} (${counts.article})
                </button>` : ''}
            </div>
        `;
    }

    let footerHtml = '';
    if (!showAll && totalCount > 0) {
        footerHtml = `
            <div class="search-dropdown-footer" onclick="viewAllSearchResults(document.getElementById('desktop-search-input')?.value || '', false)">
                <div class="search-footer-info">
                    <span class="material-symbols-rounded">search</span>
                    <span>${t('search_all_results_for')} <strong>"${escapeHtml(query)}"</strong> (${totalCount})</span>
                </div>
                <kbd class="search-footer-kbd">↵ Enter</kbd>
            </div>
        `;
    }

    containerEl.innerHTML = `
        <div class="search-dropdown-body">
            ${filterTabsHtml}
            <div class="media-row-list">
                ${rowsHtml}
            </div>
        </div>
        ${footerHtml}
    `;
}

export function clearDesktopSearch(e) {
    if (e) {
        e.stopPropagation();
        e.preventDefault();
    }
    const input = document.getElementById('desktop-search-input');
    const clearBtn = document.getElementById('desktop-search-clear');
    const searchBar = document.getElementById('header-search-bar');
    const resultsBox = document.getElementById('desktop-search-results');

    if (input) {
        input.value = '';
        input.focus();
    }
    if (clearBtn) clearBtn.classList.remove('show');
    if (searchBar) searchBar.classList.remove('has-value');
    if (resultsBox) {
        renderDesktopEmptyState(resultsBox);
    }
}

export function closeDesktopSearchDropdown() {
    const res = document.getElementById('desktop-search-results');
    if (res) res.classList.remove('show');
    const backdrop = document.getElementById('spotlight-backdrop');
    if (backdrop) backdrop.classList.remove('show');
    desktopActiveIndex = -1;
}

export function applySearchQuery(queryOrEl, isMobile = false) {
    let query = '';
    let mobile = !!isMobile;

    if (queryOrEl && typeof queryOrEl === 'object' && queryOrEl.dataset) {
        query = queryOrEl.dataset.query || queryOrEl.dataset.id || '';
        if (queryOrEl.dataset.mobile !== undefined) {
            mobile = queryOrEl.dataset.mobile === 'true';
        }
    } else {
        query = queryOrEl || '';
    }

    addSearchHistory(query);
    if (mobile) {
        const input = document.getElementById('mobile-search-input');
        if (input) {
            input.value = query;
            handleMobileSearch(query);
        }
    } else {
        const input = document.getElementById('desktop-search-input');
        if (input) {
            input.value = query;
            input.focus();
            handleDesktopSearch(query);
        }
    }
}

export function viewAllSearchResults(query, isMobile = false) {
    if (!query || !query.trim()) return;
    addSearchHistory(query);

    if (isMobile) {
        const container = document.getElementById('mobile-search-body');
        if (container) renderMobileResults(query.trim(), container, true);
    } else {
        const resultsBox = document.getElementById('desktop-search-results');
        if (resultsBox) renderDesktopResults(query.trim(), resultsBox, true);
    }
}

export function handleSelectSearchResult(titleOrEl, imgUrl, isMobile = false) {
    let title = '';
    let img = '';
    let mobile = false;

    if (titleOrEl && typeof titleOrEl === 'object' && titleOrEl.dataset) {
        title = titleOrEl.dataset.searchTitle || '';
        img = titleOrEl.dataset.searchImg || '';
        mobile = titleOrEl.dataset.searchMobile === 'true';
    } else {
        title = titleOrEl || '';
        img = imgUrl || '';
        mobile = !!isMobile;
    }

    addSearchHistory(title);
    if (mobile) {
        closeMobileSearch();
    } else {
        closeDesktopSearchDropdown();
        const input = document.getElementById('desktop-search-input');
        if (input) input.blur();
    }

    if (typeof window.openStoryDetail === 'function') {
        window.openStoryDetail(title, img);
    }
}

